import FileDragAndDrop from "./FileDragAndDrop";

const LedgerCorrection = () => {
  return <FileDragAndDrop />;
};

export default LedgerCorrection;
